"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionDuplicateModal = void 0;
var tslib_1 = require("tslib");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var collection_duplicate_modal_ctrl_1 = require("./collection.duplicate.modal.ctrl");
var collection_duplicate_modal_style_1 = require("./collection.duplicate.modal.style");
(0, theme_1.addStyles)(collection_duplicate_modal_style_1.Style);
var CollectionDuplicateModal = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionDuplicateModal, _super);
    function CollectionDuplicateModal(ctx, collections) {
        var _this = _super.call(this, ctx) || this;
        _this.ctrl = new collection_duplicate_modal_ctrl_1.CollectionDuplicateModalCtrl(collections);
        return _this;
    }
    Object.defineProperty(CollectionDuplicateModal.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', { className: collection_duplicate_modal_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: collection_duplicate_modal_style_1.CSS.content }, [
                    (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_DUPLICATE_CONFIRM, { count: this.ctrl.collections.length }))
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    CollectionDuplicateModal.prototype.submit = function () {
        return this.ctrl.duplicateCollections(null);
    };
    return CollectionDuplicateModal;
}(modal_form_component_1.ModalFormComponent));
exports.CollectionDuplicateModal = CollectionDuplicateModal;
//# sourceMappingURL=collection.duplicate.modal.js.map